import { useStytchMember } from '@stytch/react/b2b'

import { useCurrentAccountContext } from '@/components/accounts/CurrentAccountProvider'
import useLocalStorageUIDotDev from './useLocalStorageUIDotDev'

export default function useLocalStorage<T>(
  key: string,
  initialValue: T,
  includeAccountInKey = true,
) {
  const { member } = useStytchMember()
  const { currentAccount } = useCurrentAccountContext()
  const fullKey = `${key}-${member?.external_id || 'logged-out'}${
    currentAccount && includeAccountInKey ? `-${currentAccount.id}` : ''
  }`

  return useLocalStorageUIDotDev(fullKey, initialValue)
}
